import { BaseDashboardActionItem } from '@uplift/ui-v2';
import React from 'react';
import { DrawOutlined } from '@mui/icons-material';
import { Typography } from '@mui/material';
import { useHistory } from 'react-router';
import { ROUTING_CONFIG } from '@uplift/constants';


type PhysicianUnsignedCollaborativeAgreementsProps = {
  stateIds: string[];
};


export const PhysicianUnsignedCollaborativeAgreements: React.VFC<PhysicianUnsignedCollaborativeAgreementsProps> = (props) => {
  const history = useHistory();

  return (
    <BaseDashboardActionItem
      title={<Typography><b>{props.stateIds.length}</b> Counter-sign Collaborative Practice Agreement{props.stateIds.length > 1 ? 's' : ''}</Typography>}
      body={(
        <Typography variant="body2" sx={{ mt: -1 }}>
          Your NP has signed - your counter-signature is required to activate the agreement
        </Typography>
      )}
      color="danger"
      icon={<DrawOutlined />}
      action={{
        handleClick: () => {
          history.push(ROUTING_CONFIG.documentsCenter);
        },
        text: 'Review & Sign'
      }}
    />
  );
};
